import { IRefIds } from 'constants/refs';
import { del, get, post, put } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';
import {
  IConceptLinkerValidator,
  IConceptLinkerValidatorCreate,
  IConceptLinkerValidatorEdit,
} from 'types/conceptLinkerValidator';

export class ConceptLinkerValidatorModel extends BaseModel<
  IConceptLinkerValidator,
  IConceptLinkerValidatorEdit
> {
  constructor(options: IModelOptions) {
    super(options);
    this.ref = IRefIds.conceptLinkerValidator;
    this.gridName = 'ConceptLinkerValidator';
    this.getGridColumns();
  }

  async getGrid() {
    await super.getGrid();
    this.gridData = await get<IConceptLinkerValidator[]>('concept-linker-validator');
    this.loadingGrid = false;
    this.render();
  }

  async createValidation(data: IConceptLinkerValidatorCreate) {
    const response = await post<{ id: number; message: string }>('concept-linker-validator', data);
    await this.getGrid();
    return response;
  }

  async delete() {
    await del(`concept-linker-validator/${this.itemId}`);
    this.itemId = -1;
    await this.getGrid();
  }

  async reload() {
    await super.reload();
    await this.getGrid();
  }

  async loadItemData(itemId: number) {
    return await get<IConceptLinkerValidatorEdit>(`concept-linker-validator/${itemId}`);
  }

  async processMock(validationId: number): Promise<void> {
    await post(`concept-linker-validator/${validationId}/process-mock-mode2`, {});
    await this.reload();
  }

  async changePriority(itemId: number, priority: number) {
    await put(`/concept-linker-validator/${itemId}/change-priority`, { priority });
  }
}
